import './VirtualGamesModule.less';

import React, { memo } from 'react';

import i18n from '@i18n';
import { fireGAEvent } from '@/analytics';
import { vhSports } from '@/virtualgames/services/vh-service';
import { VIRTUAL_GAMES } from '@/routing/routes';
import { navigate } from '@/routing';
import PageModule from '@/common/components/page-module/PageModule';

function VirtualGamesModule() {
    const sport = vhSports[Math.floor(Math.random() * vhSports.length)];
    function onClick() {
        fireGAEvent('Homepage', 'Virtual Games Module', `Virtual game ${sport.name}`);
        navigate(VIRTUAL_GAMES, { sportSlugPart: sport.name });
    }
    return (
        <PageModule
            className="virtual-games"
            title={i18n('nikeOne.virtual')}
            description={i18n('virtual.games.module.msg')}
            onClick={onClick}
        >
            <div className="virtual-module-wrap">
                <div className={'virtual-games-image virtual-sport-id' + sport.id} />
            </div>
        </PageModule>
    );
}

export default memo(VirtualGamesModule);
